import React from "react"
import {Route} from "react-router-dom"
import {useLocation} from "react-router-dom"

const GTM = process.env.REACT_APP_GTM_CONTAINER

const Tracker = () => {
    const location = useLocation()
    React.useEffect(() => {
        console.log({location})
        if (typeof window.ga === 'function') {
            const page = location.pathname + location.search + location.hash
            if (GTM) {
                console.info(`send pageview GTM: ${page}`)
                window.ga("gtm1.set", 'page', page)
                window.ga('gtm1.send', 'pageview')
            } else {
                console.info(`send pageview: ${page}`)
                window.ga('set', 'page', page)
                window.ga('send', 'pageview')
            }

        }
    }, [location])
    return null

}
  
 

export default Tracker



// WEBPACK FOOTER //
// ./src/components/Tracker/Tracker.js